var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconOpenEye(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_304_1963",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.4725 0H0V24H23.4725V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_304_1963)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.7362 3C17.0097 3 21.3971 6.88 22.3175 12C21.3981 17.12 17.0097 21 11.7362 21C6.46275 21 2.07535 17.12 1.15503 12C2.07437 6.88 6.46275 3 11.7362 3ZM11.7362 19C13.7309 18.9996 15.6663 18.3068 17.2257 17.0352C18.7852 15.7635 19.8762 13.9883 20.3203 12C19.8746 10.0133 18.7828 8.24 17.2236 6.97003C15.6643 5.70005 13.7298 5.00853 11.7362 5.00853C9.74274 5.00853 7.80821 5.70005 6.24894 6.97003C4.68966 8.24 3.5979 10.0133 3.15215 12C3.59627 13.9883 4.68733 15.7635 6.24675 17.0352C7.80618 18.3068 9.7416 18.9996 11.7362 19ZM11.7362 16.5C10.569 16.5 9.44957 16.0259 8.6242 15.182C7.79884 14.3381 7.33515 13.1935 7.33515 12C7.33515 10.8065 7.79884 9.66193 8.6242 8.81802C9.44957 7.97411 10.569 7.5 11.7362 7.5C12.9035 7.5 14.0229 7.97411 14.8483 8.81802C15.6737 9.66193 16.1373 10.8065 16.1373 12C16.1373 13.1935 15.6737 14.3381 14.8483 15.182C14.0229 16.0259 12.9035 16.5 11.7362 16.5ZM11.7362 14.5C12.3847 14.5 13.0066 14.2366 13.4652 13.7678C13.9237 13.2989 14.1813 12.663 14.1813 12C14.1813 11.337 13.9237 10.7011 13.4652 10.2322C13.0066 9.76339 12.3847 9.5 11.7362 9.5C11.0878 9.5 10.4659 9.76339 10.0073 10.2322C9.5488 10.7011 9.29119 11.337 9.29119 12C9.29119 12.663 9.5488 13.2989 10.0073 13.7678C10.4659 14.2366 11.0878 14.5 11.7362 14.5Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconOpenEye);
export default __webpack_public_path__ + "static/media/icon_open_eye.797055bc97042016b474c317b0e20c8d.svg";
export { ForwardRef as ReactComponent };